module.exports = __webpack_public_path__ + "static/media/features-bg-2.45ae914b.svg";